import { combineReducers } from "redux";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import userReducer from "./slices/user";
import specificationReducer from "./slices/specification";
import compareProductReducer from "./slices/compare-product";
import specificationListReducer from "./slices/specification-list";
import popoverReducer from "./slices/popover";
import specificationExploreReducer from "./slices/specification-explore";
import inputReducer from "./slices/input";
import specificationTemplateReducer from "./slices/specification-template";
import sidebarReducer from "./slices/sidebar";
import notificationReducer from "./slices/notification";
import productAnswerReducer from "./slices/product-answers";
import inboxReducer from "./slices/inbox";
import constantsReducer from "./slices/constants";
import companyReducer from "./slices/company";
import companyMemberReducer from "./slices/company-member";
import sessionReducer from "./slices/session";
import permissionMemberReducer from "./slices/permission-member";
import itemOrderMappingReducer from "./slices/item-order-mapping";
import workspaceReducer from "./slices/workspace";
import aiChatReducer from "./slices/ai-chat";
import specificationFolderReducer from "./slices/specification-folder";
import specificationFoldersReducer from "./slices/specification-folders";
import reportReducer from "./slices/report";
import supplierResponsesAllReducer from "./slices/supplier-responses-all";
import supplierResponseSingleReducer from "./slices/supplier-response-single";
import dashboardReducer from "./slices/dashboard";

export const createNoopStorage = () => ({
  getItem(_key: string) {
    return Promise.resolve(null);
  },
  setItem(_key: string, value: any) {
    return Promise.resolve(value);
  },
  removeItem(_key: string) {
    return Promise.resolve();
  },
});

export const storage =
  typeof window !== "undefined"
    ? createWebStorage("local")
    : createNoopStorage();

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  blacklist: [
    "specificationFolders",
    "aiChat",
    "specification",
    "specificationList",
    "compareProduct",
    "specificationExplore",
    "popover",
    "input",
    "specificationTemplate",
    "sidebar",
    "notification",
    "productAnswer",
    "inbox",
    "constants",
    "company",
    "companyMember",
    "session",
    "permissionMember",
    "itemOrderMapping",
    "workspace",
    "aiChat",
    "specificationFolder",
    "report",
    "supplierResponsesAll",
    "supplierResponseSingle",
    "dashboard",
  ],
};

export const rootReducer = combineReducers({
  user: userReducer,
  specification: specificationReducer,
  specificationList: specificationListReducer,
  compareProduct: compareProductReducer,
  specificationExplore: specificationExploreReducer,
  popover: popoverReducer,
  input: inputReducer,
  specificationTemplate: specificationTemplateReducer,
  sidebar: sidebarReducer,
  notification: notificationReducer,
  productAnswer: productAnswerReducer,
  inbox: inboxReducer,
  constants: constantsReducer,
  company: companyReducer,
  companyMember: companyMemberReducer,
  session: sessionReducer,
  permissionMember: permissionMemberReducer,
  itemOrderMapping: itemOrderMappingReducer,
  workspace: workspaceReducer,
  aiChat: aiChatReducer,
  specificationFolder: specificationFolderReducer,
  specificationFolders: specificationFoldersReducer,
  report: reportReducer,
  supplierResponsesAll: supplierResponsesAllReducer,
  supplierResponseSingle: supplierResponseSingleReducer,
  dashboard: dashboardReducer,
});
